import { OPEN_AI_axios_adapter } from "./OPEN_AI_axios_adapter";
import { OPEN_AI_ENDPOINTS, OPEN_AI_MODEL, OPEN_AI_QUERY } from "./OPEN_AI_constant";

/**
 * 
 * UserName : RahulNexintain
 * Email : rahul@nexintain.com
 * https://www.themoviedb.org/settings/api
 * https://developer.themoviedb.org/reference/intro/getting-started
 * 
 */

const OPEN_AI_api_service = {

    //Generate quality and unique possible no of MCQ from the following movie metadata and generate JSON response which contains question ID and Answer ID: 
    getQuestionsFromMovieMetadata: async (movieMetadata) => {
        //console.log("movieMetadata : ",movieMetadata);
        const newMovieMetadata = {
            "_id": "1",
            "type": "movie",
            "displayName": "Andaz Apna Apna",
            "multimedia": [
                {
                    "mediaType": "image",
                    "imageType": "thumbnail",
                    "url": "https://m.media-amazon.com/images/M/MV5BOTc3OTgwNmUtYmY2Ny00YjQ2LWE3Y2UtMDlmODg0OTY3ZmI3XkEyXkFqcGc@._V1_SX300.jpg",
                    "aspectRatio": "1:1"
                }
            ],
            "tags": [
                {
                    "type": "movieGenre",
                    "details": {
                        "songGenreName": "Action",
                        "_id": "1"
                    }
                },
                {
                    "type": "movieGenre",
                    "details": {
                        "songGenreName": "Comedy",
                        "_id": "2"
                    }
                },
                {
                    "type": "movieGenre",
                    "details": {
                        "songGenreName": "Romance",
                        "_id": "3"
                    }
                }
            ],
            "metadata": {
                "Year": "1994",
                "Runtime": "160 min",
                "imdbRating": "8.0",
                "Released": "04Nov1994",
                "Director": "Rajkumar Santoshi",
                "Plot": "Two slackers competing for the affections of an heiress inadvertently become her protectors from an evil criminal.",
                "Language": "hi",
                "Country": "in",
                "artists": [
                    {
                        "_id": "1",
                        "name": "Aamir Khan"
                    },
                    {
                        "_id": "2",
                        "name": "Salman Khan"
                    },
                    {
                        "_id": "3",
                        "name": "Raveena Tandon"
                    }
                ]
            }
        }
        try {
            const response = await OPEN_AI_axios_adapter.post(`${OPEN_AI_ENDPOINTS.CHAT}`, {
                model: OPEN_AI_MODEL.GPT_4O_MINI,
                store: true,
                messages: [
                    {
                        role: "system",
                        content: OPEN_AI_QUERY.QUERY_4
                    },
                    { role: "user", content: `Movie Metadata:\n${JSON.stringify(newMovieMetadata, null, 2)}` }
                ]
            });
            //console.log("getQuestionsFromMovieMetadata duration : ",response?.duration)
            const content = response || null;
            return content;
        } catch (error) {
            //console.log("getQuestionsFromMovieMetadata duration : ",error?.duration)
            console.error("OpenAI generation error:", error);
            return {
                success: false,
                message: error.message || "Unknown error",
                data: null
            };
        }
    },

    getQuestionsFromMoviesListMetadata: async (moviesList) => {
        try {
            const response = await OPEN_AI_axios_adapter.post(`${OPEN_AI_ENDPOINTS.CHAT}`, {
                model: OPEN_AI_MODEL.GPT_4,
                messages: [
                    //{ role: "system", content: "You are a helpful assistant." },
                    { role: "user", content: moviesList }
                ]
            });
            return response.data;
        } catch (error) {
            return error;
        }
    },

};

export default OPEN_AI_api_service;